import { ComponentBase } from '@abstracts/component-base';
import { Component, Injector, OnDestroy, OnInit } from '@angular/core';
import { plainToClass } from 'class-transformer';
import { interval, Subscription } from 'rxjs';
import { ChargingStationStausForCustomerDto } from '../../../dto/chargingStationStausForCustomerDto';
import { ChargingStationsService } from '../../../services/entity/charging-stations.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-dashboard-charging-points',
  templateUrl: './dashboard-charging-points.component.html',
  styleUrls: ['./dashboard-charging-points.component.scss']
})
export class DashboardChargingPointsComponent extends ComponentBase implements OnInit, OnDestroy {

  public className = 'DashboardChargingPointsComponent';

  private refreshEntity: Subscription;
  public chargingPointsStatus: ChargingStationStausForCustomerDto

  public isOperator: boolean;
  public max: number;

  constructor(
    private chargingStationsService: ChargingStationsService, 
    private activatedRoute: ActivatedRoute,
    injector: Injector
  ) { 
    super(injector) 
  }

  ngOnInit(): void {
    super.ngOnInit();

    if (this.authenticationService.userHasRole('Operator')) this.isOperator = true;

    this.refreshStatus();
    this.setRefreshCC();
  }

  refreshStatus() {
    if(this.isOperator) {
      this.chargingStationsService.getChargingPointStatusOfCustomer(this.activatedRoute.parent.snapshot.params.key).subscribe(result => {
        this.chargingPointsStatus = result;
        this.max = this.calculateMax()
      }, error => {});
    } else {
      this.chargingStationsService.getChargingPointsStatus().subscribe(result => {
        this.chargingPointsStatus = result;
        this.max = this.calculateMax()
      }, error => {});
    }
  }

  calculateMax() {
    let max = this.chargingPointsStatus.online + this.chargingPointsStatus.charging + this.chargingPointsStatus.busy + this.chargingPointsStatus.offline
    return max;
  }

  setRefreshCC() {
    this.refreshEntity = interval(15000).subscribe(async (val) => {
      this.refreshStatus();
    })
  }
  ngOnDestroy() {
    this.refreshEntity.unsubscribe();
  }
}
